/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ITableBrowserViewProps } from './table-browser';

export default (props: ITableBrowserViewProps) => {
    return (
        <section className='table-browser'>
            <div className='table-browser__container'>
                <header className='table-browser__header'>
                    <div>
                        <p className='table-browser__eyebrow'>Internal tool</p>
                        <h1 className='table-browser__title'>Channel Table Browser</h1>
                        <p className='table-browser__description'>
                            Review channel database records by schema, table, columns, sorting, and pagination.
                        </p>
                    </div>
                </header>

                <div className='table-browser__search-card'>{props.searchComponent}</div>

                <div className='table-browser__table-card'>
                    <div className='table-browser__table-header'>
                        <h2 className='table-browser__table-title'>Results</h2>
                        <p className='table-browser__table-subtitle'>Use pagination to browse additional records.</p>
                    </div>

                    <div className='table-browser__table-scroll'>{props.table}</div>
                </div>
            </div>
        </section>
    );
};
